import styled from '@emotion/styled'
import { BorderRadixes } from '../enums/BorderRadixes'
import Box from './Box'
import ClosedActivityDetails from './ClosedActivityDetails'
import ExpandedActivityDetails from './ExpandedActivityDetails'
import { memo } from 'react'
import { Activity, Client } from '../../../pure-js/types/GrooverTypes'
import { SIXTEEN_PX, TWELVE_PX } from '../enums/Spacings'
import expandIcon from '/public/expandIcon.svg'
import collapseIcon from '/public/collapseIcon.svg'
import useAppState from '../hooks/useAppState'
import { getGrooverText, getGrooverTextStyle } from '../libs/GrooverTextRepository'

type Props = {
  activity: Activity
  client?: Client | null
  expanded: boolean
  onExpand: () => void
  onOpenGoogleMaps: (e: React.MouseEvent<HTMLDivElement>) => void
}

const ActivityDetails = ({ activity, client, expanded, onExpand, onOpenGoogleMaps }: Props) => {
  const { state } = useAppState()
  const language = state.user?.language
  const titleStyle = getGrooverTextStyle('headings.h5-dark')

  return (
    <ActivityBox fullWidth fullPadding spacing={SIXTEEN_PX} onClick={onExpand}>
      <Box fullWidth direction="row" align="center" gap={TWELVE_PX}>
        <img
          src={expanded ? collapseIcon : expandIcon}
          width={16}
          height={16}
          style={{ flexShrink: 0 }}
          alt={getGrooverText('userWeb.activityDetail.activityDetails.toggleAlt', language)}
        />
        <Box style={{ width: '100%' }} direction="column">
          <span style={titleStyle}>{activity.name}</span>
          {!expanded && <ClosedActivityDetails activity={activity} />}
        </Box>
      </Box>
      {expanded && <ExpandedActivityDetails activity={activity} client={client} onOpenGoogleMaps={onOpenGoogleMaps} />}
    </ActivityBox>
  )
}

const ActivityBox = styled(Box)`
  cursor: pointer;
  user-select: none;
  border: 1px solid #1b9323;
  border-radius: ${BorderRadixes.moderate};
  overflow: hidden;
  max-width: 100%;

  @media (max-width: 1024px) {
    font-size: 14px;
  }
`

export default memo(ActivityDetails)
